import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Sparkles, X } from 'lucide-react';

interface VersionModalProps {
  version: string;
  changelog: string;
  onClose: () => void;
}

export const VersionModal: React.FC<VersionModalProps> = ({ version, changelog, onClose }) => {
  return (
    <AnimatePresence>
      <motion.div 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      >
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }} 
          animate={{ scale: 1, opacity: 1 }}
          className="bg-black border border-white/20 p-8 rounded-3xl max-w-lg w-full shadow-2xl relative"
        >
          <button onClick={onClose} className="absolute top-4 right-4 text-white/50 hover:text-white">
            <X size={20} />
          </button>
          
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-yellow-500/20 rounded-2xl text-yellow-500">
              <Sparkles size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">¡Actualización {version}!</h2>
              <p className="text-xs text-white/50 uppercase tracking-widest">Novedades y Mantenimiento</p>
            </div>
          </div>

          <div className="text-sm text-white/70 whitespace-pre-line mb-8 max-h-[300px] overflow-y-auto">
            {changelog}
          </div>

          <button 
            onClick={onClose}
            className="w-full bg-white text-black py-4 rounded-xl font-bold uppercase tracking-widest text-sm hover:bg-white/90 transition-colors"
          >
            Entendido, a trabajar
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
